var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid"},[_c('b-link',[_c('b-row',_vm._l((_vm.works),function(work,index){return _c('b-col',{key:index,attrs:{"cols":"12","xl":"4","lg":"6"}},[_c('work-card',{attrs:{"work":work}})],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }